import { render } from "./MatchTheLetters.vue?vue&type=template&id=47e04d1a&scoped=true"
import script from "./MatchTheLetters.vue?vue&type=script&lang=js"
export * from "./MatchTheLetters.vue?vue&type=script&lang=js"

import "./MatchTheLetters.vue?vue&type=style&index=0&id=47e04d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e04d1a"]])

export default __exports__